import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter, map } from 'rxjs/operators';
import { AppConfig } from 'src/app/config/app-config';
import { AppConfigService } from 'src/app/config/app-config.service';

@Component({
  selector: 'bom-link-to-publicweb',
  templateUrl: './link-to-publicweb.component.html',
  styleUrls: ['./link-to-publicweb.component.scss'],
})
export class LinkToPublicwebComponent implements OnInit {
  appConfig: AppConfig;
  showLinkToPublicWeb: boolean;
  linkToPublicWebUrl: string;
  publicwebContextUrl: string;

  constructor(private appConfigService: AppConfigService, public router: Router) {}

  ngOnInit(): void {
    this.appConfig = this.appConfigService.getConfig();
    this.showLinkToPublicWeb = this.appConfig.showLinkToPublicWeb;
    this.linkToPublicWebUrl = this.appConfig.linkToPublicWebUrl;
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        map(event => event as NavigationEnd)
      )
      .subscribe(event => {
        this.publicwebContextUrl = this.linkToPublicWebUrl + this.getPublicWebUrlEnd(event.url);
      });
  }

  private getPublicWebUrlEnd(url: string) {
    if (url.startsWith('/projekter/')) {
      const segments = url.split('/').slice(2);

      if (segments.indexOf('mine') === 0) {
        return '/Projekt/Mine';
      }

      const sagIndex = segments.indexOf('sag');
      if (sagIndex >= 0 && segments.indexOf('eksternsag') < 0) {
        const sagId = segments[sagIndex + 1];
        return `/Sag/Vis/${sagId}`;
      }

      const fortsaetIndex = segments.indexOf('fortsaet');
      if (fortsaetIndex >= 0) {
        const projektId = segments[fortsaetIndex + 1];
        return `/Projekt/Vis/${projektId}`;
      }
    }

    return '';
  }
}
